<div class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
  <div class="text-center">
    <p class="text-base font-semibold text-primary-600">404</p>
    <h1 class="mt-4 text-3xl font-bold tracking-tight text-king-blue sm:text-5xl">
      {{ 'PAGE.NOT_FOUND.TITLE' | translate }}
    </h1>
    <p class="mt-6 text-base leading-7 text-gray-800">{{ 'PAGE.NOT_FOUND.INTRO' | translate }}</p>
    <div class="mt-10 flex items-center justify-center gap-x-6">
      <a
        class="rounded bg-primary-600 px-3.5 py-2.5 text-sm text-white shadow-sm hover:bg-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
        routerLink="/"
        >{{ 'PAGE.NOT_FOUND.CTA' | translate }}</a
      >
    </div>
  </div>
</div>
